import environment from '@shared/config/environments'
// todo разбить константы по сущностям, в разные файлы
const MAIN_PATH = '/' as const
const SPA = `${MAIN_PATH}spa` as const
const GOSUSLUGI_PATH = `${MAIN_PATH}gosuslugi` as const
const ONBOARDING_PATH = `${MAIN_PATH}onboarding` as const
const CREDIT_HOLIDAYS_PATH = `${MAIN_PATH}credit-holidays` as const
const LOAN_RESTRUCT_PATH = `${MAIN_PATH}restrukturizatsiya-kredita` as const
const LOANS_PATH = `${MAIN_PATH}loans` as const
const LOAN_PATH = `${MAIN_PATH}loans/:loanId` as const
const LOAN_ISSUE_PATH = `${MAIN_PATH}loans/issue/:requestId` as const
const LOAN_FA_PATH = `${MAIN_PATH}loans/fa` as const
const LIMITS_PATH = `${MAIN_PATH}limits`
const ARREST_PATH = `${LOAN_PATH}/arrest` as const
const SERVICE_PATH = `${LOAN_PATH}/services/:serviceCode` as const
const REFERENCES_PATH = `${MAIN_PATH}references` as const
const SPECIFIC_REFERENCE_PATH = `${REFERENCES_PATH}/:referenceType`
const GOSUSLUGI_INFO_PATH = `${MAIN_PATH}gosuslugi-info` as const
const EARLY_REPAYMENT_PATH = `${LOAN_PATH}/early-repayment/:repaymentType/create` as const
const REFILL_PATH = `${LOAN_PATH}/refill` as const
const AUTH_PATH = `${environment.baseApi}/Auth/SignIn/` as const
const LOGOUT_PATH = `${environment.baseApi}/Auth/SignOut` as const
const HISTORY_OPERATIONS_PATH = `${MAIN_PATH}operations` as const
const HISTORY_OPERATION_PATH = `${HISTORY_OPERATIONS_PATH}/:operationId` as const
const HISTORY_OPERATION_RECEIPT_PATH = `${HISTORY_OPERATION_PATH}/receipt` as const
const PAY = 'pay' as const
const SPA_PAY_URL = `${SPA}/${PAY}/` as const
const SPA_PAY_URL_RESULT = `${SPA}/${PAY}/result/:mdOrder` as const
const PAY_PHONE_PATH = `${MAIN_PATH}pay/phone` as const
const PAY_SERVICE_PATH = `${MAIN_PATH}pay/[id]` as const
const PERSONAL_OFFER_PATH = `${MAIN_PATH}personal_offer` as const
const WALLET_INFO = `${LIMITS_PATH}/wallet-info` as const
const PHONE_BILL = `${LIMITS_PATH}/phone-bill` as const
const TRANSFER_CARD_TO_CARD = `${LIMITS_PATH}/transfer-card-to-card` as const
const REPLENISHMENT_WALLET_ACCOUNT = `${LIMITS_PATH}/replenishment-wallet-account` as const
const NCPK_PATH = `${MAIN_PATH}ncpk` as const
const NCPK = 'ncpk' as const
const SPA_NCPK_PATH = `${SPA}/${NCPK}` as const
const ACCOUNT_OPENING_PATH = `${MAIN_PATH}accountsopen` as const
const PROMOTION_APPLY = `${MAIN_PATH}cards/promotion-apply` as const
const TEMPLATE = 'template' as const
const TRANSFER = 'transfer' as const
const PAYMENT = 'payment' as const
const FREE_CONNECTION_PATH = `${MAIN_PATH}free-connection` as const
const FREE_CONNECTION_CARD_ID_PATH = `${MAIN_PATH}free-connection/[cardId]` as const
const FREE_CONNECTION_CARD_ID_COUNTER_PATH = `${MAIN_PATH}free-connection/[cardId]/counter` as const

const BANK_PRODUCTS_PATH = `${MAIN_PATH}page/bankproducts` as const
const CARDS_PATH = `${MAIN_PATH}cards` as const
const CARDS_OPEN_PATH = `${CARDS_PATH}/open` as const
const CARDS_REQUEST_SIGNER = `${CARDS_PATH}/signDocument` as const
const TEMPLATE_PAYMENT_PATH = `${MAIN_PATH}${TEMPLATE}/${PAYMENT}` as const
const TEMPLATE_TRANSFER_PATH = `${MAIN_PATH}${TEMPLATE}/${TRANSFER}` as const
const AUTOPAYMENT_PATH = `${MAIN_PATH}autopayment` as const
const SUBSCRIPTION_PATH = `${MAIN_PATH}subscription` as const
const ADD_CARD_PATH = `${CARDS_PATH}/add` as const
const CARD_DISCOUNT_INFO_PATH = `${CARDS_PATH}:hashPan/discount` as const

const OFFERS_PATH = `https://www.mtsbank.ru/offers` as const
const SBP_PATH = `${MAIN_PATH}transfer/sbp` as const
const SPA_SBP_PATH = `${SPA}/transfer/sbp` as const
const SBP_RESULT_PATH = `${MAIN_PATH}transfer/sbp/result` as const
const SPA_SBP_RESULT_PATH = `${SPA}/transfer/sbp/result` as const
const CARD_TO_CARD = 'CardToCard' as const
const RESULT = 'result' as const
const PAY_CARD_TO_CARD = `${TRANSFER}/${CARD_TO_CARD}` as const
const PAY_CARD_TO_CARD_RESULT = `${SPA}/${TRANSFER}/${CARD_TO_CARD}/${RESULT}/:mdOrder` as const
const OFFICES_AND_ATMS = 'https://www.mtsbank.ru/ofisi-i-bankomati/'

const DEPOSITS_OPEN_PATH = `${MAIN_PATH}deposits/open/:step`

const EXCLUDED_NAVBAR_PAGES: string[] = [ONBOARDING_PATH, PAY_PHONE_PATH, PAY_SERVICE_PATH]

const MILLISECONDS_PER_DAY = 86400000 // 24 * 60 * 60 * 1000

const ONBOARDING_VERSION = '1.0'

const ONBOARDING_API_NAME = 'pl-onboarding'

const STATIC_HOST_ORIGIN = 'https://staticpayment.ssl.mts.ru'
const IB_SERVICE_URL = 'https://staticpayment.ssl.mts.ru/js/772e5300-abaa-11f0-b908-d156260000001.js'

const TOOLS_PATH = 'https://payment.mts.ru/tools'

const CASHBACK_PATH = 'https://cashback.mts.ru'
const CASHBACK_REDIRECT = `https://login.mts.ru/amserver/oauth2/sso?at=:token&redirect_uri=${CASHBACK_PATH}`
const TRANSFER_GBI_SERVICE = 'js/fhp.js'
const MTSDENGI_APK_PATH = 'https://www.mtsbank.ru/chastnim-licam/vse-servici/mtsdengi-apk/'
const SMS_DELIVERY_PATH = `${CARDS_PATH}/dst/[applicationid]` as const

const GAMES_PATH = `${MAIN_PATH}spa/categories/games` as const

const localStorageFields = {
  isBalanceHidden: 'isBalanceHidden',
} as const

const mockService = [
  {
    serviceId: '21976',
    categoryName: 'comeback',
    subline:
      'Аккаунты РФ и стран СНГ. Комиссия за конвертацию — до 10%. Деньги поступят на аккаунт в течение 15 мин. В редких случаях — до 2 часов.',
    providerName: 'Steam',
    icon: 'Steam_06032024.png',
    inn: '5190103184',
    hidden: false,
    searchInvoicesEnabled: false,
    autopaymentDisabled: true,
    payOnCreditEnabled: false,
    payByQrEnabled: false,
    balanceInquiryEnabled: false,
    mtsCategoryId: 10,
    limits: {
      min: 35000,
      max: 1500000,
    },
    bindingTypes: [],
    regions: [
      'ULY',
      'PV',
      'KLU',
      'MAG',
      'PRI',
      'RYA',
      'SAK',
      'SAR',
      'TAM',
      'TOM',
      'MOW',
      'SPE',
      'STA',
      'TYU',
      'YEV',
      'S',
      'AMU',
      'BA',
      'KHA',
      'ALT',
      'ARK',
      'BU',
      'DA',
      'KEM',
      'NEN',
      'KO',
      'KR',
      'ME',
      'IVA',
      'KDA',
      'MUR',
      'NVS',
      'TA',
      'U',
      'TY',
      'VGG',
      'VLA',
      'IN',
      'SZ',
      'KHM',
      'KIR',
      'KOS',
      'NIZ',
      'PNZ',
      'VLG',
      'CE',
      'UD',
      'CHE',
      'CR',
      'KYA',
      'SVE',
      'VOR',
      'AST',
      'BRY',
      'CU',
      'YAR',
      'ZAB',
      'AD',
      'KGN',
      'KL',
      'KRS',
      'RUS',
      'LIP',
      'SA',
      'CHU',
      'KAM',
      'NGR',
      'OMS',
      'PSK',
      'TUL',
      'TVE',
      'ORL',
      'PER',
      'ROS',
      'SAM',
      'SE',
      'SMO',
      'YAN',
      'AL',
      'BEL',
      'IRK',
      'KB',
      'KC',
      'KGD',
      'KK',
      'MO',
      'ORE',
      'Ug',
      'C',
      'DV',
    ],
    params: [
      {
        title: 'Аккаунт Steam (не НИК)',
        name: 'id1',
        type: 'StringField',
        description:
          'Аккаунты РФ и стран СНГ. Комиссия за конвертацию - до 10%. Деньги поступят на аккаунт в течение 15 мин. В редких случаях — до 2 часов.',
        hidden: false,
        maxLength: 40,
        serverValidation: false,
        readOnly: false,
        required: true,
        displayOrder: 1,
        features: {
          showInHistory: true,
        },
      },
    ],
    features: {
      tsp_picture_web: 'Steam_alt_12022024.jpg',
      iterationOff: true,
      tsp_url: 'steam',
      fee: 5,
      displayOrder: 1,
      country_web: 'Россия, Страны СНГ',
      merchant_association_for_WEB: '21261',
      templatesDisabled: true,
      category_web: 'Сервисы',
      templateOff: true,
    },
  },
]

export {
  SPA,
  ARREST_PATH,
  SERVICE_PATH,
  EARLY_REPAYMENT_PATH,
  MAIN_PATH,
  LOANS_PATH,
  LOAN_PATH,
  LOAN_ISSUE_PATH,
  LOAN_FA_PATH,
  REFILL_PATH,
  STATIC_HOST_ORIGIN,
  GOSUSLUGI_INFO_PATH,
  GOSUSLUGI_PATH,
  ONBOARDING_PATH,
  REFERENCES_PATH,
  SPECIFIC_REFERENCE_PATH,
  CREDIT_HOLIDAYS_PATH,
  LOAN_RESTRUCT_PATH,
  AUTH_PATH,
  LOGOUT_PATH,
  EXCLUDED_NAVBAR_PAGES,
  SBP_PATH,
  SPA_SBP_PATH,
  SBP_RESULT_PATH,
  SPA_SBP_RESULT_PATH,
  HISTORY_OPERATIONS_PATH,
  HISTORY_OPERATION_PATH,
  HISTORY_OPERATION_RECEIPT_PATH,
  MILLISECONDS_PER_DAY,
  ONBOARDING_VERSION,
  ONBOARDING_API_NAME,
  localStorageFields,
  PAY,
  LIMITS_PATH,
  WALLET_INFO,
  PHONE_BILL,
  TRANSFER_CARD_TO_CARD,
  REPLENISHMENT_WALLET_ACCOUNT,
  NCPK_PATH,
  ADD_CARD_PATH,
  SPA_PAY_URL_RESULT,
  PAY_CARD_TO_CARD,
  PAY_CARD_TO_CARD_RESULT,
  PERSONAL_OFFER_PATH,
  RESULT,
  TRANSFER_GBI_SERVICE,
  SPA_PAY_URL,
  CASHBACK_REDIRECT,
  CASHBACK_PATH,
  SPA_NCPK_PATH,
  ACCOUNT_OPENING_PATH,
  OFFERS_PATH,
  TEMPLATE_PAYMENT_PATH,
  TEMPLATE_TRANSFER_PATH,
  AUTOPAYMENT_PATH,
  SUBSCRIPTION_PATH,
  CARDS_PATH,
  BANK_PRODUCTS_PATH,
  MTSDENGI_APK_PATH,
  CARDS_OPEN_PATH,
  PROMOTION_APPLY,
  SMS_DELIVERY_PATH,
  CARDS_REQUEST_SIGNER,
  FREE_CONNECTION_PATH,
  FREE_CONNECTION_CARD_ID_PATH,
  FREE_CONNECTION_CARD_ID_COUNTER_PATH,
  CARD_DISCOUNT_INFO_PATH,
  DEPOSITS_OPEN_PATH,
  OFFICES_AND_ATMS,
  GAMES_PATH,
  IB_SERVICE_URL,
  mockService,
  TOOLS_PATH,
}
